import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

const PayrollReportsPeriodDetails = ({ selectedPeriod, summary, formatCurrency }) => {
  const { t, i18n } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Calendar className="h-5 w-5" />
        {t('payrollRep.periodDetails')}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div>
          <p className="text-sm font-medium text-muted-foreground">{t('payrollRep.period')}</p>
          <p className="text-lg font-semibold">
            {t('payrollRep.periodRange', {
              start: new Date(selectedPeriod.start_date).toLocaleDateString(i18n.language),
              end: new Date(selectedPeriod.end_date).toLocaleDateString(i18n.language),
            })}
          </p>
        </div>
        <div>
          <p className="text-sm font-medium text-muted-foreground">{t('payrollRep.status')}</p>
          <Badge variant={
            selectedPeriod.status === 'APPROVED' ? 'success' :
            selectedPeriod.status === 'CLOSED' ? 'outline' : 'secondary'
          }>
            {selectedPeriod.status}
          </Badge>
        </div>
        <div>
          <p className="text-sm font-medium text-muted-foreground">{t('payrollRep.netToPay')}</p>
          <p className="text-lg font-semibold text-green-600">{formatCurrency(summary.total_net)}</p>
        </div>
        <div>
          <p className="text-sm font-medium text-muted-foreground">{t('payrollRep.totalDeductions')}</p>
          <p className="text-lg font-semibold text-red-600">{formatCurrency(summary.total_deductions)}</p>
        </div>
      </div>
    </CardContent>
  </Card>
  );
};

export default PayrollReportsPeriodDetails;
